import {
    FaBullhorn,
    FaUsers,
    FaWhatsapp,
    FaInstagram,
    FaYoutube,
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt,
} from "react-icons/fa";

import {
    GiStomach,
    GiMicroscope,
} from "react-icons/gi";

import {
    FcStart,
    FcGoogle
} from "react-icons/fc";

import {
    FiMapPin
} from "react-icons/fi";

import { 
    IoLogoWhatsapp 
} from "react-icons/io";

import { 
    FaSquareInstagram 
} from "react-icons/fa6";

export const iconMap = {
    bullhorn: FaBullhorn,
    users: FaUsers,
    whatsapp: FaWhatsapp,
    instagram: FaInstagram,
    youtube: FaYoutube,
    phone: FaPhone,
    email: FaEnvelope,
    address: FaMapMarkerAlt,
    stomach: GiStomach,
    microscope: GiMicroscope,
    youtube: FcStart,
    google: FcGoogle,
    map: FiMapPin,
    ioWhatsapp: IoLogoWhatsapp,
    instagram6: FaSquareInstagram,
};
